import { render, staticRenderFns } from "./SafetyRadiationDashboard.vue?vue&type=template&id=21b46363&scoped=true&"
import script from "./SafetyRadiationDashboard.vue?vue&type=script&lang=js&"
export * from "./SafetyRadiationDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SafetyRadiationDashboard.vue?vue&type=style&index=0&id=21b46363&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b46363",
  null
  
)

export default component.exports